import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "10",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.661 11.355a1 1 0 0 1 0 1.691l-4.727 2.985a1 1 0 0 1-1.534-.845V9.214a1 1 0 0 1 1.534-.845Z"
    }, null, -1)
  ])))
}
export default { render: render }